import { z } from 'zod'

export type PaymentReturnSearchParams = Record<string, string | string[] | undefined>
export type TossPaymentReturn = { status: 'check'; paymentId: string } | { status: 'cancelled' | 'failed' | 'invalid' }

// A return is a result lookup, never permission to start another purchase.
export function isLegacyTossPaymentReturn(params: PaymentReturnSearchParams): boolean {
  return (
    params.complete === 'true' &&
    params.pg_provider === 'TOSS_PAYMENTS' &&
    (params.payment_type === 'LUMP_SUM' || params.payment_type === 'IPAD')
  )
}

export function parseTossPaymentReturn(params: PaymentReturnSearchParams): TossPaymentReturn {
  const cancelCodes = ['PAY_PROCESS_CANCELED', 'PAYMENT_CANCELLED', 'USER_CANCEL']
  if (typeof params.code === 'string' && cancelCodes.includes(params.code)) {
    return { status: 'cancelled' }
  }
  if (params.imp_success === 'false' || params.code) {
    return { status: 'failed' }
  }
  const ids = [params.paymentId, params.payment_id, params.merchant_uid].filter((value) => value !== undefined)
  const paymentIdSchema = z
    .string()
    .min(1)
    .max(128)
    .regex(/^[A-Za-z0-9._:-]+$/)
  const parsedIds = ids.map((value) => paymentIdSchema.safeParse(value))
  const id = parsedIds[0]
  if (!id?.success || parsedIds.some((candidate) => !candidate.success || candidate.data !== id.data)) {
    return { status: 'invalid' }
  }
  return { status: 'check', paymentId: id.data }
}

export function createTossPaymentReturnUrl(currentUrl: string): URL {
  // Do not copy checkout/product/coupon/delivery values into the result contract.
  const url = new URL('/subscribes/payment/return', new URL(currentUrl).origin)
  return url
}
